import React from 'react'

const HomePage = (props) => {
    
    return (
        <div className='homepage'>
            <div id='content'>
                <div>
                    <h1>TISHA PLASTIC PRODUCTS</h1>
                    <h3>PLastic Manufacturer</h3>
                </div>
                <div>
                    <h5>Collection of household items and other plastic products</h5>
                    {/* <h5>To have a demo of this web application, use the credentials given below to login.</h5> */}
                    <div id='credentials'>
                        {/* <h5>Email: sourav@gmail.com</h5> */}
                       
                    </div>
                    
                </div>

            </div>
        </div>
    )
}

export default HomePage